export default __webpack_public_path__ + "static/media/87.4845228f.png";